import { Component, OnInit, Injector } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { isEmpty } from 'lodash';
import { AddressesService } from '../../../Services/addresses/Addresses';
import { ActionApiService } from '../../../Services/action-api/action-api.service';
import { Router } from '@angular/router';
//import { SplunkAnalyticsService } from "../../../Services/splunk-analytics/splunk-analytics-service";

@Component({
	selector: 'button-link',
	host: { '[class]': 'myCustomClass' },
	template: `
		<a
			[tabindex]="control.disabled ? -1 : 0"
			target="{{ control.attributes.target }}"
			(click)="handleButtonClick()"
			[innerHTML]="control.attributes.title"
			[class]="control.attributes.buttonPosition"
			[ngClass]="{ 'bundle-button': control.attributes.class === 'bundle-button', disabled: control.disabled }"
		>
		</a>
	`,
	styleUrls: ['./button-link.component.scss'],
})
export class ButtonLinkComponent extends BaseComponent implements OnInit {
	isMPQ3DRShowAddressEdit: boolean;

	constructor(
		injector: Injector,
		private router: Router,
		private actionApiService: ActionApiService,
		private Addresses: AddressesService
	) {
		super(injector);
	}

	ngOnInit() {
		this.initAddressVisibilitySubscription();
	}

	handleButtonClick() {
		if (this.control.disabled) {
			return;
		}
		if (this.control.attributes.goBackOnClick) {
			// back button gtm event
			const dataObj = {
				event: 'GAEvent',
				route: window.location.pathname,
				eventCategory: 'Home_Quoting',
				eventAction: 'LinkClick',
				CurrentItemNameInHTML: '',
				DesiredItemNameinHTML: 'Back',
				eventLabel: 'Back',
				eventValue: '',
				callback: '',
				nonInteraction: 'nonInteraction',
			};

			if (this.isMPQ3DRShowAddressEdit) {
				this.Addresses.showEditAddressReplaySubject.next(false);
			}

			const globalAttributes = this.storeService.getGlobalAttributes();
			if (globalAttributes && globalAttributes['previousStage'] && globalAttributes['previousStage'] != '') {
				this.router.navigate([globalAttributes['previousStage']]);
			} else {
				sessionStorage.setItem('modal:show', 'true');
				window.location.href = window.location.origin + '/InitInterview';
			}

			return;
		}

		// this.gtmService.GAEvent('Sent to Quoting', 0, 'SysEvent');
		setTimeout(() => {
			let brigeTime = new Date();

			this.ajaxAction();
			if (!isEmpty(this.control.attributes) && !isEmpty(this.control.attributes.url)) {
				if (this.control.attributes.url.indexOf('?') !== -1) {
					window.location.href = this.control.attributes.url + '&st=' + brigeTime.getTime();
				} else {
					window.location.href = this.control.attributes.url + '?st=' + brigeTime.getTime();
				}
			}
		}, 0);
	}

	initAddressVisibilitySubscription(): void {
		this.Addresses.showEditAddressReplaySubject.subscribe((shouldShow: boolean) => {
			this.isMPQ3DRShowAddressEdit = shouldShow;
		});
	}
}
